import { type FC } from "react";
import { Navigate, generatePath, useParams } from "react-router-dom";

import { AbsoluteRoute, type RouteParams } from "../../core/routes";

// NB! This is Lens Studio Submission contract
// DO NOT MODIFY redirect
export const LensSubmission: FC = () => {
    const { submissionId } = useParams<Partial<RouteParams[AbsoluteRoute.SUBMIT]>>();

    if (!submissionId) {
        return <Navigate to=".." />;
    }
    return (
        <Navigate
            to={generatePath(AbsoluteRoute.SUBMIT_FLOW_REDIRECTOR, {
                submissionId,
            })}
        />
    );
};
